import { type ComputedArrivalData } from "@src/appV2/redesign/ArrivalTime/computeArrivalData";
import { ArrivalTimeLabel } from "@src/appV2/redesign/ArrivalTime/TimeLabel";
import { Span } from "@src/appV2/redesign/system/ui-components";
import { differenceInMinutes, parseISO } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { utcToZonedTime } from "date-fns-tz";

import { BookabilityCriteriaCardTitleText } from "../BookabilityCriteriaCardTitleText";

interface ShiftBottomSheetArrivalTimeTitleProps {
  computedArrivalData: ComputedArrivalData;
  workplaceTimezone: string;
}

export function ShiftBottomSheetArrivalTimeTitle(props: ShiftBottomSheetArrivalTimeTitleProps) {
  const { computedArrivalData, workplaceTimezone } = props;
  const { targetArrivalTime, departureTime, gracePeriodInMinutes, shiftStartIso } =
    computedArrivalData;
  const minutesTilDeparture = differenceInMinutes(departureTime, new Date());
  const startDatetime = parseISO(shiftStartIso);
  const shouldAlreadyLeave =
    targetArrivalTime > startDatetime || minutesTilDeparture <= gracePeriodInMinutes;

  const title = shouldAlreadyLeave
    ? "Leave now and clock in before "
    : "Leave soon and clock in before ";

  return (
    <BookabilityCriteriaCardTitleText>
      <Span>{title}</Span>
      <ArrivalTimeLabel datetime={utcToZonedTime(targetArrivalTime, workplaceTimezone)} />
    </BookabilityCriteriaCardTitleText>
  );
}
